import { Injectable } from '@angular/core';
import { WhatsappIntegration } from '../../../interfaces/common/whatsappIntegration';
import { Observable } from 'rxjs';
import { WhatsappIntegrationApi } from '../api/whatsappIntegration.api';

@Injectable({
    providedIn: 'root'
})
export class WhatsAppIntegrationService extends WhatsappIntegration {
    constructor(private api: WhatsappIntegrationApi) {
        super();
    }
    sendBulkMessage(listOfCustomers: any,token:string): Observable<any> {
        return this.api.sendBulkMessage(listOfCustomers,token);
    }
    sendMessage(phone: any,token:string,url?:string): Observable<any> {
        return this.api.sendMetaMessage(phone,token,url);
    }
    whatsappMessageList(bussinessId:any , token:any): Observable<any> {
        return this.api.getWhatsappList(bussinessId,token);
    }
    metaWhatsappMessageList(whatsappTemplateId:any , token:any): Observable<any> {
        return this.api.getMetaWhatsappList(whatsappTemplateId,token);
    }
    sendMessageWithFormData(customer: any, token: string): Observable<any> {
        return this.api.sendMessage(customer, token);
    }  
    getIntegrations(): Observable<any> {
        throw new Error('Method not implemented.');
    }
    createIntegration(data: any): Observable<any> {
        throw new Error('Method not implemented.');
    }



}